<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td colspan="3">
      <!--            <div v-if="item.adjustments && item.adjustments.length > 0">-->
      <div>
        <div
          v-for="(adjustment, adjustmentIndex) in item.adjustments"
          class="grid grid-cols-6 gap-5 py-1 items-center divide-none border-0 border-none"
        >
          <div class="col-span-4 flex items-center gap-2">
            <Menu
              as="div"
              class="relative text-left inline-block w-full"
            >
              <div>
                <MenuButton
                  class="inline-flex items-center w-full justify-between rounded border border-gray-400 px-3 py-2 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300"
                >
                  {{ adjustment.reason || 'Reason' }}
                </MenuButton>
              </div>
            </Menu>
          </div>
          <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
            <input
              class="rounded w-full border-gray-400 border text-blue-600 text-base px-3 py-1 font-semibold text-center"
              type="number"
              step="1"
              disabled
              :value="adjustment.amount"
            />
          </div>
          <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
            <a
              v-if="canEdit"
              @click="deleteAdjustment(adjustment)"
            >
              <!-- <MinusCircleIcon class="h-5 w-5 text-gray-300" aria-hidden="true" /> -->
              <img
                :src="asset('images/minus.svg')"
                style="width: 18px"
                class="text-gray-300 mx-auto"
              />
            </a>
          </div>
        </div>

        <div
          v-if="canEdit"
          class="grid grid-cols-6 gap-5 py-1 items-center divide-none border-0 border-none"
        >
          <div class="col-span-4 flex items-center gap-2">
            <!--                        <Menu as="div" class="relative text-left inline-block w-full">-->
            <!--                            <div>-->
            <!--                                <MenuButton class="inline-flex items-center w-full justify-between rounded border border-gray-400 px-3 py-2 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300">-->
            <!--                                    {{ adjustmentForm.reason }}-->
            <!--                                    <ChevronDownIcon class="-mr-1 ml-2 h-4 w-4 text-gray-400" aria-hidden="true" />-->
            <!--                                </MenuButton>-->
            <!--                            </div>-->
            <!--                            <transition enter-active-class="transition ease-out duration-100" enter-from-class="opacity-0 scale-95" enter-to-class="opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">-->
            <!--                                <MenuItems class="justify-end origin-top-right absolute right-0 mt-2 w-full rounded-md shadow-lg bg-gray-100 divide-y divide-gray-400 focus:outline-none z-50">-->
            <!--                                    <div class="">-->
            <!--                                        <MenuItem v-slot="{ active }">-->
            <!--                                            <a @click="setAdjustmentReason('Damaged')" href="#" :class="[active ? 'bg-gray-400 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100']">-->
            <!--                                                Damaged-->
            <!--                                            </a>-->
            <!--                                        </MenuItem>-->
            <!--                                        <MenuItem v-slot="{ active }">-->
            <!--                                            <a @click="setAdjustmentReason('Missing')" href="#" :class="[active ? 'bg-gray-400 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100']">-->
            <!--                                                Missing-->
            <!--                                            </a>-->
            <!--                                        </MenuItem>-->
            <!--                                    </div>-->
            <!--                                </MenuItems>-->
            <!--                            </transition>-->
            <!--                        </Menu>-->
            <div class="input-group w-full">
              <div class="input-control">
                <select v-model="adjustmentForm.reason">
                  <option
                    v-for="val in adjustmentReasons"
                    :value="val.name"
                  >
                    {{ val.name }}
                  </option>
                  <!--                                    <option value="Damaged">-->
                  <!--                                        Damaged-->
                  <!--                                    </option>-->
                </select>
              </div>
            </div>
          </div>
          <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
            <input
              class="rounded w-full border-gray-400 border text-blue-600 text-base px-3 py-1 font-semibold text-center"
              type="number"
              step="1"
              v-model="adjustmentForm.amount"
            />
          </div>
          <div class="col-span-1 text-center text-sm uppercase text-gray-600 font-semibold">
            <button
              @click="submitAdjustment()"
              type="button"
              class="inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm bg-gray-500 text-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'

export default {
  components: {
    'base-row': TableRow,
    Link,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronDownIcon
  },

  mixins: [RowProps],

  props: {
    canEdit: {
      type: Boolean,
      required: true
    },
    adjustmentReasons: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      adjustmentForm: this.$inertia.form({
        type: 'adjustment',
        amount: 0,
        reason: 'Miscount/Human error'
      }),
      deleteAdjustmentForm: this.$inertia.form({})
    }
  },

  computed: {},

  methods: {
    triggerSelected() {
      this.$emit('selected', this.item)
    },
    setAdjustmentReason(reason) {
      this.adjustmentForm.reason = reason
    },
    submitAdjustment() {
      this.$emit('adjust', this.item.id, this.adjustmentForm)
      // this.adjustmentForm.reset();
    },
    deleteAdjustment(adjustment) {
      this.$emit('deleteAdjustment', this.item.id, adjustment.id)
    }
  }
}
</script>
